// extracted by mini-css-extract-plugin
export default {"icon":"Settings_icon__ND2NA","container":"Settings_container__hr4fX"};